<div class="visa-login-container flex flex-col sm:block justify-center items-center w-full mat-typography mt-0" [ngClass]="mobile ? 'mt-0' : 'mt-0' ">

  <ng-container *ngIf="initiateResponseCard">
    <form [action]="initiateResponseCard.acsUrl" method="post" id="acs-form" class="cdk-visually-hidden" hidden>
      <input name="MD" [value]="initiateResponseCard.acsMD" id="MD" hidden>
      <input name="PaReq" [value]="initiateResponseCard.acsPayload" id="PaReq" hidden>
      <input name="TermUrl" [value]="initiateResponseCard.acsTermUrl" id="TermUrl" hidden>
    </form>
  </ng-container>

  <div class="flex flex-wrap justify-center items-center pb-6 pl-0 pr-0 mr-0 ml-0" style=" border-radius: 12px;" [ngClass]="[loading ? 'pt-0' : 'pt-0', mobile ? 'pb-0 mb-2 w-full min-h-3/4' : 'pb-0 mb-4 min-h-350']">

    <div class="container flex justify-center items-center w-full">
      <mat-spinner
        *ngIf="loadingSdk"
        class="loading-spinner"
        [color]="color"
        [diameter]="diameter"
      >
      </mat-spinner>
    </div>

    <div class="form-container w-full mb-12" *ngIf="!loadingSdk">

      <div
        *ngIf="!recognized"
      >
        <mat-tab-group class="rounded-0">
          <mat-tab label="New" [disabled]="loading">

            <form [formGroup]="notRecognizedForm" class="rounded-0 mt-4 flex flex-wrap flex-row items-center justify-evenly mb-6">

              <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                <mat-label>Card Number</mat-label>
                <input
                  matInput
                  placeholder="4512 0022 5656 8569"
                  [imask]="{mask: '0000 0000 0000 0000'}"
                  formControlName="cardNumber"
                  id="cardnumber"
                  #cardNumber
                  autocomplete="cc-number"
                  [disabled]="loading"
                  required
                  [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                  Please enter {{(cardNumberControl.value.name ? cardNumberControl.value.name : 'a valid card number')| lowercase}}.
                </mat-error>
                <svg id="ccicon" #ccicon class="ccicon" width="750" height="471" viewBox="0 0 750 471" version="1.1"
                     xmlns="http://www.w3.org/2000/svg"
                >
                </svg>
                <mat-hint align="end"><strong><span [style.color]="cardNumberControl.hasError('minLength') || cardNumberControl.hasError('maxLength') || cardNumberControl.hasError('required') ? 'red' : 'green'">{{cardNumberControl.value ? cardNumberControl.value.length - 3 : '0'}}</span> / 16</strong></mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                <mat-label>Cardholder Full Name</mat-label>
                <input
                  matInput
                  required
                  formControlName="cardholderFullName"
                  placeholder="Mr John Doe"
                  autocomplete="cc-name"
                  [disabled]="loading"
                  [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                  Please enter {{(cardholderFullNameControl.value?.name ? cardholderFullNameControl.value?.name : 'a valid name')| lowercase}}.
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                <mat-label>Expiry Month</mat-label>
                <input
                  matInput
                  required
                  type="number"
                  autocomplete="cc-exp-month"
                  formControlName="expiryMonth"
                  [disabled]="loading"
                  placeholder="05"
                  [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                  Please enter {{(expiryMonthControl.value.name ? expiryMonthControl.value.name : 'a valid expiry month')| lowercase}}.
                </mat-error>
                <mat-hint align="end"><strong><span [style.color]="expiryMonthControl.hasError('minLength') || expiryMonthControl.hasError('maxLength') || expiryMonthControl.hasError('required') ? 'red' : 'green'">{{expiryMonthControl.value ? expiryMonthControl.value?.toString().length : '0'}}</span> / 2</strong></mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                <mat-label>Expiry Year</mat-label>
                <input
                  matInput
                  required
                  placeholder="2025"
                  autocomplete="cc-exp-year"
                  [disabled]="loading"
                  formControlName="expiryYear"
                  [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                  Please enter {{(expiryYearControl.value.name ? expiryYearControl.value.name : 'a valid expiry year')| lowercase}}.
                </mat-error>
                <mat-hint align="end"><strong><span [style.color]="expiryYearControl.hasError('minLength') || expiryYearControl.hasError('maxLength') || expiryYearControl.hasError('required') ? 'red' : 'green'">{{expiryYearControl.value ? expiryYearControl.value?.toString().length : '0'}}</span> / 4</strong></mat-hint>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                <mat-label>Security Code (CVV)</mat-label>
                <input
                  matInput
                  [type]="hide ? 'password' : 'text'"
                  required
                  autocomplete="new-password"
                  id="cc"
                  name="cc"
                  formControlName="cvv"
                  [disabled]="loading"
                  maxlength="3"
                  [errorStateMatcher]="matcher"
                >
                <mat-error *ngIf="showErrors">
                  Please enter {{(cvvControl.value.name ? cvvControl.value.name : 'a valid cvv')| lowercase}}.
                </mat-error>
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </mat-form-field>

              <div class="w-11/12 sm:w-2/5 relative cdk-visually-hidden"></div>

            </form>

            <div class="flex justify-center items-center flex-col mb-6">
              <img src="../../../assets/icons/Icons/visa-checkout.svg" class="mb-4">
              <p class="text-xs mb-0 pb-0 w-1/2 text-center">Your information will be shared with participating payment networks, service providers, and otherwise described in our Privacy Notice to give you the appropriate experience.</p>
            </div>

            <!--                <div class="w-1/2 flex justify-start">-->
            <!--                  <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">-->
            <!--                    <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />-->
            <!--                  </svg>-->
            <!--                </div>-->
            <!--                <div class="w-1/2 flex justify-start">-->
            <!--                  <strong class="text-xs">Back</strong>-->
            <!--                </div>-->

            <div class="flex flex-wrap justify-center items-center flex-row confirm-container w-full click-to-pay-background-white p-4 shadow-md" [ngClass]="mobile ? 'mr-0 mb-1 mt-0' : 'mb-4 mt-2'">
              <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-coral flex justify-center items-center" (click)="back()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                <strong class="text-xs">Back</strong>
              </button>
              <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-primary flex justify-center items-center" (click)="cancelTransaction()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                <strong class="text-xs">Cancel</strong>
              </button>
<!--              [ngStyle]="{'background-color': headerColor}"-->
              <button class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral" (click)="callCheckout('NEW')" [disabled]="notRecognizedForm.invalid || loading" [ngClass]="mobile ? 'w-11/12' : 'w-36' ">
                <strong class="text-xs">Continue</strong>
              </button>
            </div>
          </mat-tab>
          <mat-tab label="Returning" [disabled]="loading">
            <ng-container *ngIf="!otpSent && !srcProfilesReturned">

              <form [formGroup]="identityForm" class="rounded-0 mt-8 flex flex-wrap flex-col items-center justify-evenly" [ngClass]="mobile ? '' : 'mt-20'">

                <img src="../../../assets/icons/Icons/visa-checkout.svg" class="mb-8">

                <div class="w-11/12 sm:w-2/5 relative">
                  <mat-form-field appearance="outline" class="w-full relative">
                    <mat-label>Please enter your email</mat-label>
                    <input
                      matInput
                      [placeholder]="'Please enter your email'"
                      [disabled]="identityForm?.controls?.verificationType?.value.invalid || loading"
                      required
                      formControlName="email"
                      [errorStateMatcher]="matcher"
                    >
                    <mat-error *ngIf="showErrors">
                      Please enter {{(emailControl.value.name ? emailControl.value.name : 'a valid email')| lowercase}}.
                    </mat-error>
                  </mat-form-field>

                  <p>By continuing, you agree to Visa's Privacy Notice.</p>
                </div>

              </form>

              <div class="flex justify-center items-center flex-row confirm-container w-full click-to-pay-background-white p-4 shadow-md" [ngClass]="mobile ? 'mr-0 mb-1 mt-0 flex-wrap' : 'mb-4 mt-2'">
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-coral flex justify-center items-center" (click)="back()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                  <strong class="text-xs">Back</strong>
                </button>
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-primary flex justify-center items-center" (click)="cancelTransaction()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                  <strong class="text-xs">Cancel</strong>
                </button>
                <button #continueButtonIdentityForm class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral" (click)="callIdentityLookup()" [disabled]="identityForm.invalid" [ngClass]="mobile ? 'w-11/12' : 'w-36' ">
                  <span *ngIf="!loading" class="flex items-center"><strong class="text-xs">Continue</strong></span>
                  <mat-spinner
                    *ngIf="loading"
                    class="loading-spinner mb-1 mt-1"
                    color="primary"
                    diameter="20"
                  >
                  </mat-spinner>
                </button>
              </div>

              <div class="flex justify-center items-center flex-col confirm-container" [ngClass]="mobile ? 'mr-0 mb-1 mt-0' : 'mb-4 mt-2 ml-4'">

              </div>
            </ng-container>

            <ng-container *ngIf="otpSent && !srcProfilesReturned && !addCardState">

              <form [formGroup]="otpForm" class="rounded-0 mt-8 flex flex-wrap flex-col items-center justify-evenly">

                <img src="../../../assets/icons/Icons/visa-checkout.svg" class="mb-6">

                <div class="text-center">
                  <p class="mb-3 text-lg">Welcome Back</p>
                  <p class="text-xs pb-0 mb-0">Enter the one-time code sent to:</p>
                  <div class="flex flex-row justify-center items-center"><p class="text-xs font-bold mr-1">{{ emailControl?.value }}</p><p class="underline cursor-pointer" (click)="changeConsumerIdentity()">(Not you?)</p></div>
                </div>

                <div class="w-11/12 sm:w-2/5 relative">
                  <mat-form-field appearance="outline" class="w-full relative">
                    <mat-label>Please enter your 6-digit OTP</mat-label>
                    <input
                      matInput
                      [placeholder]="'Please enter your otp'"
                      required
                      formControlName="otp"
                      [errorStateMatcher]="matcher"
                    >
                    <mat-error>
                      Please enter {{('a valid otp')| lowercase}}.
                    </mat-error>
                  </mat-form-field>

                  <p class="underline mb-0 pb-0 cursor-pointer text-center" (click)="resendOtp()">Resend Code</p>
                </div>
              </form>

              <div class="flex justify-center items-center flex-row confirm-container w-full click-to-pay-background-white p-4 shadow-md" [ngClass]="mobile ? 'mr-0 mb-1 mt-0 flex-wrap' : 'mb-4 mt-2'">
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-coral flex justify-center items-center" (click)="backToIdentityValidation()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                  <strong class="text-xs">Back</strong>
                </button>
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-primary flex justify-center items-center" (click)="cancelTransaction()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                  <strong class="text-xs">Cancel</strong>
                </button>
                <button
                  #continueButtonIdentityForm
                  class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral"
                  [ngStyle]="{'background-color': headerColor}"
                  (click)="callCompleteIdValidationClicked()"
                  [disabled]="identityForm.invalid"
                  [ngClass]="mobile ? 'w-11/12' : 'w-36' "
                >
                  <span *ngIf="!loading" class="flex items-center">
                    <strong class="text-xs">Continue</strong>
                  </span>
                  <mat-spinner
                    *ngIf="loading"
                    class="loading-spinner mb-1 mt-1"
                    color="primary"
                    diameter="20"
                  >
                  </mat-spinner>
                </button>
              </div>

            </ng-container>

            <ng-container *ngIf="srcProfilesReturned && otpSent && !addCardState">

              <div class="id-tokens-container w-full p-8">
              <!-- multiple profiles ? Do only masked cards for now -->
                <p class="font-bold text-lg mb-1 pb-0">Select a card</p>
                <mat-radio-group class="flex flex-col" [(ngModel)]="selectedCard">
                  <mat-radio-button class="flex flex-row p-4 w-full mb-3 rounded-md shadow-md" style="background-color: #FAFAFA" *ngFor="let cards of srcProfileReturns?.profiles[0].maskedCards" [value]="cards">
                    <div class="w-full flex items-center flex-row">
                      <img class="mr-2" [src]="cards.digitalCardData.artUri" height="64" width="64">
                      <div class="text-lg font-bold">.... {{ cards.panLastFour }}</div>
                    </div>
                  </mat-radio-button>
                  <mat-radio-button class="flex flex-row p-4 w-full mb-3 rounded-md shadow-md" style="background-color: #FAFAFA" [value]="{type: 'ADD'}">
                    <div class="w-full flex items-center flex-row">
                      <img class="mr-2" src="../../../assets/icons/Payment_Cards/PaymentCard_card_add.png" height="64" width="64">
                      <div class="text-lg font-bold">Add New Card</div>
                    </div>
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <div class="flex justify-center items-center flex-row confirm-container w-full click-to-pay-background-white p-4 shadow-md" [ngClass]="mobile ? 'mr-0 mb-1 mt-0 flex-wrap' : 'mb-4 mt-2'">
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-coral flex justify-center items-center" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' " (click)="backToIdentityValidation()">
                  <strong class="text-xs">Back</strong>
                </button>
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-primary flex justify-center items-center" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' " (click)="cancelTransaction()">
                  <strong class="text-xs">Cancel</strong>
                </button>
                <button
                  #continueButtonSelectCard
                  class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral"
                  [ngStyle]="{'background-color': headerColor}"
                  (click)="callCheckout('EXISTING')"
                  [disabled]="loading || !selectedCard"
                  [ngClass]="mobile ? 'w-11/12' : 'w-36' "
                >
                  <span *ngIf="!loading" class="flex items-center">
                    <strong class="text-xs">Continue</strong>
                  </span>
                  <mat-spinner
                    *ngIf="loading"
                    class="loading-spinner mb-1 mt-1"
                    color="primary"
                    diameter="20"
                  >
                  </mat-spinner>
                </button>
              </div>

            </ng-container>

            <ng-container *ngIf="srcProfilesReturned && otpSent && addCardState">

              <form [formGroup]="notRecognizedForm" class="rounded-0 mt-4 flex flex-wrap flex-row items-center justify-evenly mb-6">

                <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                  <mat-label>Card Number</mat-label>
                  <input
                    matInput
                    placeholder="4512 0022 5656 8569"
                    [imask]="{mask: '0000 0000 0000 0000'}"
                    formControlName="cardNumber"
                    id="cardnumber"
                    #cardNumber
                    autocomplete="cc-number"
                    [disabled]="loading"
                    required
                    [errorStateMatcher]="matcher"
                  >
                  <mat-error *ngIf="showErrors">
                    Please enter {{(cardNumberControl.value.name ? cardNumberControl.value.name : 'a valid card number')| lowercase}}.
                  </mat-error>
                  <svg id="ccicon" #ccicon class="ccicon" width="750" height="471" viewBox="0 0 750 471" version="1.1"
                       xmlns="http://www.w3.org/2000/svg"
                  >
                  </svg>
                  <mat-hint align="end"><strong><span [style.color]="cardNumberControl.hasError('minLength') || cardNumberControl.hasError('maxLength') || cardNumberControl.hasError('required') ? 'red' : 'green'">{{cardNumberControl.value ? cardNumberControl.value.length - 3 : '0'}}</span> / 16</strong></mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                  <mat-label>Cardholder Full Name</mat-label>
                  <input
                    matInput
                    required
                    formControlName="cardholderFullName"
                    placeholder="Mr John Doe"
                    autocomplete="cc-name"
                    [disabled]="loading"
                    [errorStateMatcher]="matcher"
                  >
                  <mat-error *ngIf="showErrors">
                    Please enter {{(cardholderFullNameControl.value?.name ? cardholderFullNameControl.value?.name : 'a valid name')| lowercase}}.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                  <mat-label>Expiry Month</mat-label>
                  <input
                    matInput
                    required
                    type="number"
                    autocomplete="cc-exp-month"
                    formControlName="expiryMonth"
                    [disabled]="loading"
                    placeholder="05"
                    [errorStateMatcher]="matcher"
                  >
                  <mat-error *ngIf="showErrors">
                    Please enter {{(expiryMonthControl.value.name ? expiryMonthControl.value.name : 'a valid expiry month')| lowercase}}.
                  </mat-error>
                  <mat-hint align="end"><strong><span [style.color]="expiryMonthControl.hasError('minLength') || expiryMonthControl.hasError('maxLength') || expiryMonthControl.hasError('required') ? 'red' : 'green'">{{expiryMonthControl.value ? expiryMonthControl.value?.toString().length : '0'}}</span> / 2</strong></mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                  <mat-label>Expiry Year</mat-label>
                  <input
                    matInput
                    required
                    placeholder="2025"
                    autocomplete="cc-exp-year"
                    [disabled]="loading"
                    formControlName="expiryYear"
                    [errorStateMatcher]="matcher"
                  >
                  <mat-error *ngIf="showErrors">
                    Please enter {{(expiryYearControl.value.name ? expiryYearControl.value.name : 'a valid expiry year')| lowercase}}.
                  </mat-error>
                  <mat-hint align="end"><strong><span [style.color]="expiryYearControl.hasError('minLength') || expiryYearControl.hasError('maxLength') || expiryYearControl.hasError('required') ? 'red' : 'green'">{{expiryYearControl.value ? expiryYearControl.value?.toString().length : '0'}}</span> / 4</strong></mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
                  <mat-label>Security Code (CVV)</mat-label>
                  <input
                    matInput
                    [type]="hide ? 'password' : 'text'"
                    required
                    autocomplete="new-password"
                    id="cc"
                    name="cc"
                    formControlName="cvv"
                    [disabled]="loading"
                    maxlength="3"
                    [errorStateMatcher]="matcher"
                  >
                  <mat-error *ngIf="showErrors">
                    Please enter {{(cvvControl.value.name ? cvvControl.value.name : 'a valid cvv')| lowercase}}.
                  </mat-error>
                  <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                </mat-form-field>

                <div class="w-11/12 sm:w-2/5 relative cdk-visually-hidden"></div>

              </form>

              <div class="flex justify-center items-center flex-col mb-6">
                <img src="../../../assets/icons/Icons/visa-checkout.svg" class="mb-4">
                <p class="text-xs mb-0 pb-0 w-1/2 text-center">Your information will be shared with participating payment networks, service providers, and otherwise described in our Privacy Notice to give you the appropriate experience.</p>
              </div>

              <div class="flex flex-wrap justify-center items-center flex-row confirm-container w-full click-to-pay-background-white p-4 shadow-md" [ngClass]="mobile ? 'mr-0 mb-1 mt-0' : 'mb-4 mt-2'">
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-coral flex justify-center items-center" (click)="backToCardSelectionExisting()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                  <strong class="text-xs">Back</strong>
                </button>
                <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-primary flex justify-center items-center" (click)="cancelTransaction()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                  <strong class="text-xs">Cancel</strong>
                </button>
                <!--              [ngStyle]="{'background-color': headerColor}"-->
                <button class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral" (click)="callCheckout('NEW')" [disabled]="notRecognizedForm.invalid || loading" [ngClass]="mobile ? 'w-11/12' : 'w-36' ">
                  <strong class="text-xs">Continue</strong>
                </button>
              </div>

            </ng-container>

          </mat-tab>
        </mat-tab-group>
      </div>
      <div
        *ngIf="recognized"
      >
        <div *ngIf="!recognizedSelectCardState && addCardState">
          <form [formGroup]="notRecognizedForm" class="rounded-0 mt-8 flex flex-wrap flex-row items-center justify-evenly mb-6">

            <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
              <mat-label>Card Number</mat-label>
              <input
                matInput
                placeholder="4512 0022 5656 8569"
                [imask]="{mask: '0000 0000 0000 0000'}"
                formControlName="cardNumber"
                id="cardnumber"
                #cardNumber
                autocomplete="cc-number"
                [disabled]="loading"
                required
                [errorStateMatcher]="matcher"
              >
              <mat-error *ngIf="showErrors">
                Please enter {{(cardNumberControl.value.name ? cardNumberControl.value.name : 'a valid card number')| lowercase}}.
              </mat-error>
              <svg id="ccicon" #ccicon class="ccicon" width="750" height="471" viewBox="0 0 750 471" version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
              >
              </svg>
              <mat-hint align="end"><strong><span [style.color]="cardNumberControl.hasError('minLength') || cardNumberControl.hasError('maxLength') || cardNumberControl.hasError('required') ? 'red' : 'green'">{{cardNumberControl.value ? cardNumberControl.value.length - 3 : '0'}}</span> / 16</strong></mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
              <mat-label>Cardholder Full Name</mat-label>
              <input
                matInput
                required
                formControlName="cardholderFullName"
                placeholder="Mr John Doe"
                autocomplete="cc-name"
                [disabled]="loading"
                [errorStateMatcher]="matcher"
              >
              <mat-error *ngIf="showErrors">
                Please enter {{(cardholderFullNameControl.value?.name ? cardholderFullNameControl.value?.name : 'a valid name')| lowercase}}.
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
              <mat-label>Expiry Month</mat-label>
              <input
                matInput
                required
                type="number"
                autocomplete="cc-exp-month"
                formControlName="expiryMonth"
                [disabled]="loading"
                placeholder="05"
                [errorStateMatcher]="matcher"
              >
              <mat-error *ngIf="showErrors">
                Please enter {{(expiryMonthControl.value.name ? expiryMonthControl.value.name : 'a valid expiry month')| lowercase}}.
              </mat-error>
              <mat-hint align="end"><strong><span [style.color]="expiryMonthControl.hasError('minLength') || expiryMonthControl.hasError('maxLength') || expiryMonthControl.hasError('required') ? 'red' : 'green'">{{expiryMonthControl.value ? expiryMonthControl.value?.toString().length : '0'}}</span> / 2</strong></mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
              <mat-label>Expiry Year</mat-label>
              <input
                matInput
                required
                placeholder="2025"
                autocomplete="cc-exp-year"
                [disabled]="loading"
                formControlName="expiryYear"
                [errorStateMatcher]="matcher"
              >
              <mat-error *ngIf="showErrors">
                Please enter {{(expiryYearControl.value.name ? expiryYearControl.value.name : 'a valid expiry year')| lowercase}}.
              </mat-error>
              <mat-hint align="end"><strong><span [style.color]="expiryYearControl.hasError('minLength') || expiryYearControl.hasError('maxLength') || expiryYearControl.hasError('required') ? 'red' : 'green'">{{expiryYearControl.value ? expiryYearControl.value?.toString().length : '0'}}</span> / 4</strong></mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-11/12 sm:w-2/5 relative">
              <mat-label>Security Code (CVV)</mat-label>
              <input
                matInput
                [type]="hide ? 'password' : 'text'"
                required
                autocomplete="new-password"
                id="cc"
                name="cc"
                formControlName="cvv"
                [disabled]="loading"
                maxlength="3"
                [errorStateMatcher]="matcher"
              >
              <mat-error *ngIf="showErrors">
                Please enter {{(cvvControl.value.name ? cvvControl.value.name : 'a valid cvv')| lowercase}}.
              </mat-error>
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
            </mat-form-field>

            <div class="w-11/12 sm:w-2/5 relative cdk-visually-hidden"></div>

          </form>

          <div class="flex justify-center items-center flex-col mb-6">
            <img src="../../../assets/icons/Icons/visa-checkout.svg" class="mb-4">
            <p class="text-xs mb-0 pb-0 w-1/2 text-center">Your information will be shared with participating payment networks, service providers, and otherwise described in our Privacy Notice to give you the appropriate experience.</p>
          </div>

          <div class="flex justify-center items-center flex-row confirm-container w-full click-to-pay-background-white p-4 shadow-md" [ngClass]="mobile ? 'mr-0 mb-1 mt-0 flex-wrap' : 'mb-4 mt-2'">
            <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-coral flex justify-center items-center" (click)="backToSelectCardRecognized()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
              <strong class="text-xs">Back</strong>
            </button>
            <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-primary flex justify-center items-center" (click)="cancelTransaction()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
              <strong class="text-xs">Cancel</strong>
            </button>
            <!--              [ngStyle]="{'background-color': headerColor}"-->
            <button class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral" (click)="callCheckout('NEW')" [disabled]="notRecognizedForm.invalid || loading" [ngClass]="mobile ? 'w-11/12' : 'w-36' ">
              <strong class="text-xs">Continue</strong>
            </button>
          </div>
        </div>
        <div *ngIf="recognizedSelectCardState && !addCardState">
          <ng-container *ngIf="srcProfilesReturned">

            <div class="id-tokens-container w-full p-8">
              <!-- multiple profiles ? Do only masked cards for now -->
              <p class="font-bold text-lg mb-1 pb-0">Select a card</p>
              <mat-radio-group class="flex flex-col" [(ngModel)]="selectedCard">
                <mat-radio-button class="flex flex-row p-4 w-full mb-3 rounded-md shadow-md" style="background-color: #FAFAFA" *ngFor="let cards of srcProfileReturns?.profiles[0].maskedCards" [value]="cards">
                  <div class="w-full flex items-center flex-row">
                    <img class="mr-2" [src]="cards.digitalCardData.artUri" height="64" width="64">
                    <div class="text-lg font-bold">.... {{ cards.panLastFour }}</div>
                  </div>
                </mat-radio-button>
                <mat-radio-button class="flex flex-row p-4 w-full mb-3 rounded-md shadow-md" style="background-color: #FAFAFA" [value]="{type: 'ADD'}">
                  <div class="w-full flex items-center flex-row">
                    <img class="mr-2" src="../../../assets/icons/Payment_Cards/PaymentCard_card_add.png" height="64" width="64">
                    <div class="text-lg font-bold">Add New Card</div>
                  </div>
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="flex justify-center items-center flex-row confirm-container w-full click-to-pay-background-white p-4 shadow-md" [ngClass]="mobile ? 'mr-0 mb-1 mt-0 flex-wrap' : 'mb-4 mt-2'">
              <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-coral flex justify-center items-center" (click)="back()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                <strong class="text-xs">Back</strong>
              </button>
              <button class="text-lg text-white h-10 rounded-lg click-to-pay-background-primary flex justify-center items-center" (click)="cancelTransaction()" [disabled]="loading" [ngClass]="mobile ? 'w-11/12 mr-0 mb-2' : 'w-36 mr-6' ">
                <strong class="text-xs">Cancel</strong>
              </button>
              <button
                #continueButtonSelectCard
                class="text-lg text-white h-10 rounded-lg flex justify-center items-center click-to-pay-background-coral"
                [ngStyle]="{'background-color': headerColor}"
                (click)="callCheckout('EXISTING')"
                [disabled]="loading || !selectedCard"
                [ngClass]="mobile ? 'w-11/12' : 'w-36' "
              >
                  <span *ngIf="!loading" class="flex items-center">
                    <strong class="text-xs">Continue</strong>
                  </span>
                <mat-spinner
                  *ngIf="loading"
                  class="loading-spinner mb-1 mt-1"
                  color="primary"
                  diameter="20"
                >
                </mat-spinner>
              </button>
            </div>

          </ng-container>
        </div>
      </div>

<!--      <div class="button-container flex justify-center" [ngClass]="mobile ? 'flex-col-reverse' : 'flex-row'">-->

<!--        <div class="flex justify-center items-center flex-col confirm-container" [ngClass]="mobile ? 'mr-0 mb-1 mt-0' : 'mr-4 mb-4 mt-2 pl-2'">-->
<!--          <button [disabled]="loading" class="text-xl font-medium rounded-lg continue-button pl-16 pr-16 flex items-center mt-2 flex justify-center" [ngClass]="mobile ? 'w-11/12' : '' " [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">-->
<!--            <p class="p-0 m-0">CANCEL</p>-->
<!--          </button>-->
<!--        </div>-->

<!--        <div class="flex justify-center items-center flex-col confirm-container" [ngClass]="mobile ? 'mr-0 mb-1 mt-0' : 'mb-4 mt-2 ml-4'">-->
<!--          <button class="text-lg text-white h-12 mt-2 rounded-lg" [ngStyle]="{'background-color': headerColor}" (click)="formValidation()" [ngClass]="mobile ? 'w-11/12' : 'w-56' ">-->
<!--            <strong>CONTINUE</strong>-->
<!--          </button>-->
<!--        </div>-->

<!--      </div>-->
    </div>

  </div>
</div>
